import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { BaseIcon } from '@/lib/components/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryNavItem',
  props: {
  active: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "flex flex-row items-center justify-between py-3 cursor-pointer" }, _ctx.$attrs), [
    _createElementVNode("span", {
      class: _normalizeClass(["text-base font-medium", __props.active ? 'text-gray-900' : 'text-gray-400'])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createVNode(_unref(BaseIcon), {
      class: _normalizeClass([__props.active ? 'text-primary' : 'text-gray-400', "stroke-1.5"]),
      name: "chevron-right"
    }, null, 8, ["class"])
  ], 16))
}
}

})